import React, { useEffect, useMemo, useState } from 'react';
import { Container, Row } from 'reactstrap';
import { Stack } from '@mui/material';
import {
    MaterialReactTable,
    useMaterialReactTable,
    MRT_ColumnDef
} from 'material-react-table';
import axiosInstance from '../../../Utils/axiosInstance';
import { backendbaseUrl } from '../../../Utils/baseUrl';
import { toast } from 'react-toastify';
import { UserGroup } from './interface';

function UserGroupList() {
    const BooleanCell = ({ value }: { value: boolean }) => {
        return value ? (
            'true'
        ) : (
            'false'
        );
    };
    const [data, setData] = useState<UserGroup[]>([]);

    useEffect(() => {
        const fetchUserGroups = async () => {
            try {
                const response = await axiosInstance.get(`${backendbaseUrl}/company/list/group/`);

                if (response.status === 200) {
                    setData(response.data);
                }
            } catch (error: any) {
                if (error.response) {
                    if (error.response.status === 401) {
                        toast.error("Unauthorized");
                    } else {
                        toast.error(error.response.data.message || "An unknown error occurred");
                    }
                } else {
                    toast.error("Network error or server is down");
                }
            }
        };

        fetchUserGroups();
    }, []);

    const columns = useMemo<MRT_ColumnDef<UserGroup>[]>(
        () => [
            {
                header: 'Group Name',
                accessorKey: 'user_group',
            },
            {
                header: 'Apps',
                accessorKey: 'subscribed_apps',
            },
            {
                header: 'Menus',
                accessorKey: 'field_name',
            },
            {
                header: 'Create',
                accessorKey: 'create',
                Cell: ({ row }) => (row.original.create ? '✅' : '❌')
            },
            {
                header: 'Read',
                accessorKey: 'read',
                Cell: ({ row }) => (row.original.read ? '✅' : '❌')
            },
            {
                header: 'Update',
                accessorKey: 'update',
                Cell: ({ row }) => (row.original.update ? '✅' : '❌')
            },
            {
                header: 'Delete',
                accessorKey: 'delete',
                Cell: ({ row }) => (row.original.delete ? '✅' : '❌')
            }
        ],
        []
    );

    const table = useMaterialReactTable({
        columns,
        data,
        enableGrouping: true,
        initialState: {
            density: 'compact',
            expanded: true, //expand all groups by default
            grouping: ['user_group', 'subscribed_apps'], //an array of columns to group by by default (can be multiple)
            pagination: { pageIndex: 0, pageSize: 20 },
        },
        muiTableContainerProps: { sx: { maxHeight: '800px' } },
    });

    return (
        <div className="page-body">
            <Container fluid>
                <Row>
                    <Stack gap={2}>
                        <MaterialReactTable table={table} />
                    </Stack>
                </Row>
            </Container>
        </div>
    );
}

export default UserGroupList;